module.exports = __webpack_public_path__ + "img/com.electrolux.tracktrace.2970299a.webp";